<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <a-card
            :bordered="false"
            class="header-solid h-full"
            :bodyStyle="{ padding: 0 }"
        >
          <template #title>
            <a-row type="flex" align="middle">
              <a-col :span="24" :md="12">
                <h5 class="font-semibold m-0">گزارش خدمات دهندگان</h5>
              </a-col>
              <a-col
                  :span="24"
                  :md="12"
                  style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                "
              >
                <a-button
                    class="btn-outline-purple"
                    icon="search"
                    @click="isHidden = !isHidden"
                >
                  جستجو
                </a-button>
                  &nbsp;
<!--                  <a-button class="btn-outline-primary"  target="_blank" :href="`${$store.state.baseUrl}/provider-export`" >-->
<!--                      <a-icon type="upload" />  خروجی اکسل-->
<!--                  </a-button>-->
                  <ExportProvider />

              </a-col>
            </a-row>
          </template>

            <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                <a-row>
                    <div class="row">
                        <div class="col-md-6 ">
                            <div class="form-group">
                                <label style="margin-bottom:10px;">از تاریخ  </label>
                                <date-picker v-model="search.start"></date-picker>

                            </div>
                        </div>
                        <div class="col-md-6 ">
                            <div class="form-group">
                                <label style="margin-bottom:10px;"> تا تاریخ </label>
                                <date-picker v-model="search.end"></date-picker>

                            </div>
                        </div>
                    </div>
                    <a-col :md="5" style="margin:2% !important;">
                        <label class="sr-only" for="inline-form-input-name">
                            بر اساس شهر</label>
                        <a-select style="width: 100%" placeholder=" شهر" v-model="search.city_id">
                            <a-select-option value="">
                                انتخاب
                            </a-select-option>
                            <a-select-option v-for="city in cities" :value="city.id">
                                {{city.name }}
                            </a-select-option>

                        </a-select>
                    </a-col>
                    <a-col :md="5" style="margin:2% !important;">
                        <UserSearch @ids="getIds" />

                    </a-col>


                    <a-col :md="5" style="margin:2% !important;">
                        <label class="sr-only" for="inline-form-input-name">
                            بر اساس وضعیت</label>
                        <a-select style="width: 100%" placeholder=" وضعیت" v-model="search.received">
                            <a-select-option value="">
                                انتخاب
                            </a-select-option>
                            <a-select-option value="0">
                                تحویل داده نشده
                            </a-select-option>
                            <a-select-option value="1">
                                تحویل داده شده

                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :md="5" style="margin:2% !important;">
                        <label class="sr-only" for="inline-form-input-name">
                            عنوان</label>
                        <b-form-input v-model="search.title" id="inline-form-input-name"
                                      class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                    </a-col>

                </a-row>
                <a-col :md="4" style="margin:2% !important;">
                    <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                        جستجو
                    </a-button>

                </a-col>
            </b-card>
          <a-row
              style="justify-content: center; display: flex"
              v-if="$store.state.loading"
          >
            <template>
              <div>
                <a-spin />
              </div>
            </template>


          </a-row>
          <div v-else>
              <section class="w-100 p-4 text-center">
              <div class="table-responsive">
                <table class="table table-hover ">
                  <thead>
                  <tr>
                    <th scope="col">شناسه</th>
                    <th scope="col">خدمات دهنده</th>
                    <th scope="col"> شماره سفارش</th>
                    <th scope="col"> عنوان</th>
                    <th scope="col"> خریدار</th>
                    <th scope="col">قیمت اصلی</th>
                    <th scope="col">قیمت نقدی محصول</th>
                    <th scope="col"> قیمت تهاتری محصول</th>
                    <th scope="col">شهر</th>
                    <th scope="col">تاریخ</th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr v-for="row in data">
                    <th scope="row">#{{ row.id }}</th>

                      <td>
                          <b-badge  class="text-light bg-success">{{ row . presenter . information ? row.presenter.information.company_name : '' }}</b-badge>
                          <br>
                          <b-badge variant="light" class="text-dark">{{ row . presenter ? $root.full_name(row.presenter.firstname,row.presenter.lastname) : '' }}</b-badge>
                      </td>

                    <td>
                      <b-badge

                          variant="light"
                          class="bg-secondary"
                      >{{row.order_id}}</b-badge
                      >

                    </td>

                    <td>
                      <b-badge pill variant="info" class="text-dark"
                      >{{ row.title }}
                      </b-badge>
                    </td>
                      <td>
                          <b-badge pill variant="info" class="text-dark"
                          >{{ $root.full_name(row.order.user.firstname, row.order.user.lastname) }}
                          </b-badge>
                      </td>
                      <td>
                          <b-badge pill variant="info" class="text-dark"
                          >{{ $root.number_format(row.cost) }}
                          </b-badge>
                      </td>
                      <td>
                          <b-badge pill variant="info" class="text-dark"
                          >{{ $root.number_format(row.main_cash) }}
                          </b-badge>
                      </td>

                      <td>
                          <b-badge pill variant="info" class="text-dark"
                          >{{ $root.number_format(row.main_barter) }}
                          </b-badge>
                      </td>
                      <td>
                          <b-badge pill variant="info" class="text-dark"
                          >{{ row.city.name }}
                          </b-badge>
                      </td>
                      <td>
                          <b-badge variant="light" class="text-dark">{{row . created_at != null ? new Date(row . created_at).toLocaleDateString('fa-IR') : '-' }}</b-badge>
                      </td>
<!--                    -->
<!--                    <td>-->
<!--                      <a target="_blank" :href="'/products/edit/'+row.order_item.product.id" class="text-dark">{{row.order_item.product.title-->
<!--                        }}</a>-->
<!--                    </td>-->
<!--                    <td>-->
<!--                      <b-badge variant="light" class="text-dark">{{row.order_item ? $root.full_name(row.order_item.product.presenter.firstname,row.order_item.product.presenter.lastname) : ""-->
<!--                        }}</b-badge>-->
<!--                    </td>-->
                  </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <a-row class="pagination">
              <a-pagination
                  :total="total"
                  :item-render="$root.itemRender"
                  @change="getData(currentPage)"
                  v-model="currentPage"
              />
            </a-row>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>

import data from "bootstrap/js/src/dom/data";
import UserSearch from "../../components/Blocks/UserSelectMultiple.vue";
import ExportProvider from "../../components/Blocks/ExportProvider.vue";

export default {
    components: {
        UserSearch, ExportProvider
    },
  data() {
    return {
      data: [],
      cities: [],
      currentPage: 1,
      total: 0,
      isHidden: false,
      search: {
          title: "",
          seller_id:[],
          received:"",
          city_id: "",
          start: "",
          end: "",
      },
    };
  },
  methods: {
      getIds(value) {
          this.search.seller_id=value
      },
    async getData() {
      let _this = this;
      this.$store.state.loading = true;
      let url = `/providers/sell-order?page=${this.currentPage}&&seller_id=${this.search.seller_id}&&title=${this.search.title}&&received=${this.search.received}&&city_id=${this.search.city_id}&&start=${this.search.start}&&end=${this.search.end}`;
      await axios
          .get(url)
          .then(function (response) {
              console.log(response);
            _this.data = response.data.data.data;
              console.log(data)
            _this.$store.state.loading = false;
            _this.total = response.data.data.total;
            _this.currentPage = response.data.data.current_page;
          })
          .catch(function (err) {
            _this.$root.handleAxiosError(err);
          });
    },
      async getCities(){
          this.cities=[
              {'id':23,'name':'تهران'},
              {'id':1,'name':'شیراز'},
              {'id':27,'name':'مشهد'},
              {'id':34,'name':'تبریز'},
              {'id':55,'name':'ارومیه'},
          ];
      }
    
  },
  mounted() {
    this.getData();
    this.getCities();
  },
};
</script>

<style scope>
.pagination {
  display: flex;
  justify-content: center;
  margin: 15px;
}
</style>
